import axios, { AxiosError } from "axios";
import { FiltersService } from "./services/FiltersService";
import { LaneService } from "./services/LaneService";
import { RouteService } from "./services/RouteService";
import { ShipmentService } from "./services/ShipmentsService";
import { PopupNotification } from "components/PopupNotification/PopupNotification";
import { Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { DismissPopupsButton } from "components/DismissPopupsButton/DismissPopupsButton";
import { oktaAuth } from "oktaAuth";
import { ThorService } from "./services/ThorService";
import { UserManagementService } from "./services/UserManagementService";
import { bypassErrorInterceptor } from "./apiRoutes";
import { envConstants } from "../env-constants";

export const lokiAxios = axios.create({
    baseURL: envConstants.REACT_APP_LOKI_AXIOS_BASE_URL,
});

export const torAxios = axios.create({
    baseURL: envConstants.REACT_APP_TOR_AXIOS_BASE_URL,
});

torAxios.interceptors.request.use(
    (config) => {
        if (config.headers.Authorization !== "") {
            config.headers.Authorization = `Bearer ${oktaAuth.getAccessToken()}`;
        } else {
            // if Authorization header was set manually then remove  header completely. Required for AWS presignedurls to avoid exception;
            delete config.headers.Authorization;
        }
        return config;
    },
    (error) => {
        console.log("Request error: " + error);
    }
);

torAxios.interceptors.response.use(
    (response) => response,
    ({ response, config }: AxiosError) => {
        if (bypassErrorInterceptor(response, config)) {
            return response;
        }

        let id: string | number = "";

        const handleClose = () => {
            toast.dismiss(id);
        };

        const apiErrorText = response?.data.errors ? (
            <Typography variant="body2">{response?.data.errors.timeSpan[0]}</Typography>
        ) : (
            <Typography variant="body2">
                Endpoint:
                {config.url}
                <br />
                {response?.data.message}
            </Typography>
        );

        if (!toast.isActive("dismissAll")) {
            toast(<DismissPopupsButton />, {
                toastId: "dismissAll",
            });
        }

        id = toast(
            <PopupNotification
                type="error"
                title={
                    response?.data.errors
                        ? `API error: look at the details`
                        : `API error: ${response?.status} ${response?.statusText}`
                }
                details={apiErrorText}
                closeCallback={handleClose}
            />
        );

        return response;
    }
);

lokiAxios.interceptors.request.use(
    (config) => {
        config.headers.Authorization = `Bearer ${oktaAuth.getAccessToken()}`;
        return config;
    },
    (error) => {
        console.log("Request error: " + error);
    }
);

lokiAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        let id: string | number = "";

        const handleClose = () => {
            toast.dismiss(id);
        };

        const apiErrorText = error.response.data.errors ? (
            <Typography variant="body2">{error.response.data.errors.timeSpan[0]}</Typography>
        ) : (
            <Typography variant="body2">
                Endpoint:
                {error.config.url}
                <br />
                {error.response.data.message}
            </Typography>
        );

        if (!toast.isActive("dismissAll")) {
            toast(<DismissPopupsButton />, {
                toastId: "dismissAll",
            });
        }

        id = toast(
            <PopupNotification
                type="error"
                title={
                    error.response.data.errors
                        ? `API error: look at the details`
                        : `API error: ${error.response.status} ${error.response.statusText}`
                }
                details={apiErrorText}
                closeCallback={handleClose}
            />
        );
    }
);

export const services = {
    Filter: new FiltersService(),
    Lane: new LaneService(),
    Route: new RouteService(),
    Shipment: new ShipmentService(),
    Thor: new ThorService(),
    UserManagement: new UserManagementService(),
};
